export const configuration = {
  appName: "Marketplace",
  projectName: "ALICIA",
  selectedProjectOptions: ["alicia", "r3-mydas", "alliance"],
  appVersion: "1.0.0",
  defaultLanguage: "en-GB",
  languages: ["en", "gr"],
  defaultTheme: "light",
  themes: ["light", "dark"],
  multiLanguage: false,
  projectLogo: {
    src: "ALICIA_logo.png",
    alt: "ALICIA project",
  },
  projectLogoFooter: {
    src: "ALICIA_logo.png",
    alt: "ALICIA project",
  },
  projectFavicon: {
    src: "ALICIA_favicon.png",
    alt: "ALICIA",
  },
  projectHomepageImg: {
    src: "homepage_img.jpg",
    alt: "ALICIA",
  },
  euLogo: {
    src: "",
    alt: "",
    fundedBy:
      "This project is funded by the European Union under the Horizon 2020 research and innovation programme under grant agreement No 101091577.",
  },
  copyright: "© Netcompany SEE & EUI, ",
};

export const SELECTED_PROJECT =
  import.meta.env.VITE_PROJECT_NAME ?? "No project is selected";
